import { IBusStop } from "../busStop";
import { IEarlyDriveData, ILineSet } from "../lineInfo";
import { IOnBoardLine } from "./onBoardLine.types";

export class OnBoardLine implements IOnBoardLine {
  serviceUid: string;
  memberUid: string;
  allocUid: string;
  boardUid: string;
  lineRouteUid: string;
  lineRouteNo: string;
  lineRouteName: string;
  lineTurnUid: string;
  lineTypeCode: string;
  lineTypeName: string;
  campusCode: string;
  campusName: string;
  lineDirectionCode: string;
  lineDirectionName: string;
  lineDistrictCode: string;
  lineDistrictName: string;
  lineTimeCode: string;
  lineTimeName: string;
  firstBusStop: IBusStop;
  lastBusStop: IBusStop;
  getOnBusStop?: IBusStop;
  getOffBusStop?: IBusStop;
  realLastBusStopDateTime: string;
  realGetOnBusStopId: string;
  realGetOnBusStopName: string;
  realGetOnDateTime: string;
  carNo: string;
  busStops: IBusStop[];
  earlyDriveInfos: IEarlyDriveData[];
  lineSets: ILineSet[];
  requestGetOffBusStopId?: string;
  detourBeginDtm?: string;
  detourEndDtm?: string;
  detourReason?: string;

  constructor(data: IOnBoardLine) {
    this.serviceUid = data.serviceUid;
    this.memberUid = data.memberUid;
    this.allocUid = data.allocUid;
    this.boardUid = data.boardUid;
    this.lineRouteUid = data.lineRouteUid;
    this.lineRouteNo = data.lineRouteNo;
    this.lineRouteName = data.lineRouteName;
    this.lineTurnUid = data.lineTurnUid;
    this.lineTypeCode = data.lineTypeCode;
    this.lineTypeName = data.lineTypeName;
    this.campusCode = data.campusCode;
    this.campusName = data.campusName;
    this.lineDirectionCode = data.lineDirectionCode;
    this.lineDirectionName = data.lineDirectionName;
    this.lineDistrictCode = data.lineDistrictCode;
    this.lineDistrictName = data.lineDistrictName;
    this.lineTimeCode = data.lineTimeCode;
    this.lineTimeName = data.lineTimeName;
    this.firstBusStop = data.firstBusStop;
    this.lastBusStop = data.lastBusStop;
    this.getOnBusStop = data.getOnBusStop;
    this.getOffBusStop = data.getOffBusStop;
    this.realLastBusStopDateTime = data.realLastBusStopDateTime;
    this.realGetOnBusStopId = data.realGetOnBusStopId;
    this.realGetOnBusStopName = data.realGetOnBusStopName;
    this.realGetOnDateTime = data.realGetOnDateTime;
    this.carNo = data.carNo;
    this.busStops = data.busStops;
    this.earlyDriveInfos = data.earlyDriveInfos;
    this.lineSets = data.lineSets;
    this.requestGetOffBusStopId = data.requestGetOffBusStopId;
    this.detourBeginDtm = data.detourBeginDtm;
    this.detourEndDtm = data.detourEndDtm;
    this.detourReason = data.detourReason;
  }
}
